hrd.xlate = {
	language: 'none',
	dictionary: {},
	load: function(bundle, prefixes, bundles){
		bundle = (bundle === null) ? undefined : bundle;
		bundles = (bundles === null) ? undefined : bundles;
		var input = {
			bundle: bundle,
			bundles: bundles,
			prefix: prefixes
		};
		return hrd.AbstractDashboard.prototype.invokeSimpleProvider('com.hrd.struts.xlate.XlateJsonProvider', input)
			.then(xlate => {
				if(xlate.language !== this.language){
					this.dictionary = this._map2dict(xlate.dictionary);
				} else {
					this.dictionary = $.extend(true, {}, this.dictionary, this._map2dict(xlate.dictionary));
				}
				this.language = xlate.language;
				this.locale = xlate.locale;
				this.localeSpecs = xlate.localeSpecs;
			});
	},
	currentLanguage: function(){
		return this.language === 'none'? 'it' : this.language;
	},
	translate: function(key, params){
		var value = hrd.utils.getValueByPath(this.dictionary, key);
		if($.isPlainObject(value)){
			// in this case search for a property called '_'
			value = hrd.utils.getValueByPath(this.dictionary, key + '._');
		}
		var message = value ? ((typeof value == 'string') ? value : this._notLeaf(key)): this._notFound(key);
		if(params){
			message = this._replaceParams(message, params);
		}
		return message;
	},
	_notFound: function(key){
		return "???" + this.language + '.' + key + "???";
	},
	_notLeaf: function(key){
		return "!!!" + this.language + '.' + key + "!!!";
	},
	_map2dict: function(map){
		var dict = {};
		Object.keys(map)
			.sort()
			.forEach(key => {
				hrd.utils.setValueByPath(dict, key, map[key]);
				// testing if 'set' was successful
				if(hrd.utils.getValueByPath(dict, key) != map[key]){
					this._fixDictionary(dict, key);
					// try again to store
					hrd.utils.setValueByPath(dict, key, map[key]);
				}
			});
		return dict;
	},
	_fixDictionary: function(dict, key){
		var lastDot = key.lastIndexOf('.');
		var first = (lastDot == -1) ? key : key.substring(0, lastDot);
		var last = (lastDot == -1) ? '' : key.substring(lastDot + 1);
		var prev = hrd.utils.getValueByPath(dict, first);
		if(prev != undefined && !$.isPlainObject(prev)){
			hrd.utils.setValueByPath(dict, first, {'_': prev});
		} else {
			this._fixDictionary(dict, first);
		}
	},
	_replaceParams: function(message, params) {
		var re = /\{\{|\}\}|\{([^{}]+)\}/g;
		params = typeof params === 'object' ? params : Array.prototype.slice.call(arguments, 1);
	    return message.replace(re, function (m, n) {
	        if (m == "{{") { return "{"; }
	        if (m == "}}") { return "}"; }
	        /* used to solve something in the form: property|action|arg1|arg2|...|argN */
	        if(n.indexOf('|') !== -1){
	        	var tokens = n.split('|');
	        	var key = tokens[0];
	        	var action = tokens[1];
	        	var values = tokens.slice(2);
	        	return params[key][action](values);
	        } else {
	        	return params[n];
	        }
	    });
	}
};
// shortcut
window.xlate = hrd.xlate.translate.bind(hrd.xlate);